import { render, staticRenderFns } from "./batchMarkingChild.vue?vue&type=template&id=6c905aa0&scoped=true"
import script from "./batchMarkingChild.vue?vue&type=script&lang=js"
export * from "./batchMarkingChild.vue?vue&type=script&lang=js"
import style0 from "./batchMarkingChild.vue?vue&type=style&index=0&id=6c905aa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c905aa0",
  null
  
)

export default component.exports